import { all, call, put, takeEvery } from "redux-saga/effects";
import { globalLoaderText } from "redux/CommonDashboard/actions";
import { apiMethod, apiType, API_URL } from "utils";
import { IPayload } from "Model/IPayload";
import {
  setAssetAuditHistoryExcelData,
  setAssetAuditHistoryLogGridData,
  setIsGridLoading,
} from "Store/AssetInventory/AssetAuditResetHistoryLog/AssetAuditResetHistoryLogAction";
import {
  GET_ASSET_AUDIT_HISTORY_EXCEL_DATA,
  GET_ASSET_AUDIT_HISTORY_LOG_GRID_DATA,
} from "Store/AssetInventory/AssetAuditResetHistoryLog/AssetAuditResetHistoryLogTypes";
import AssetManagementApiService from "Service/AssetManagement/AssetManagementApiService";

function* getAssetAuditHistoryLogGridData(payload: any): any {
  try {
    yield put(setIsGridLoading(true));

    let payloadData: IPayload = {
      apiMethod: apiMethod.POST,
      apiType: apiType.AssetManagement,
      endpoint: `assetinventory/resetauditlog`,
      payload: payload.payload,
    };

    const response = yield call(
      AssetManagementApiService.post,
      API_URL.PostWebApp,
      payloadData
    );

    if (response) {
      yield put(setAssetAuditHistoryLogGridData(response));
      yield put(setIsGridLoading(false));
    }
    yield put(setIsGridLoading(false));
  } catch (error) {
    yield put(setAssetAuditHistoryLogGridData([]));
    yield put(setIsGridLoading(false));
  }
}

function* getAssetAuditHistoryExcelData(payload: any): any {
  try {
    yield put(globalLoaderText("Fetching Excel Data ...."));

    let payloadData: IPayload = {
      apiMethod: apiMethod.GET,
      apiType: apiType.AssetManagement,
      endpoint: `inventory/archive/assessment/export/${payload?.auditResetId}`,
      payload: null,
    };

    const response = yield call(
      AssetManagementApiService.post,
      API_URL.PostWebApp,
      payloadData
    );

    if (response) {
      yield put(setAssetAuditHistoryExcelData(response));
      yield put(globalLoaderText(""));
    }
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(setAssetAuditHistoryExcelData([]));
    yield put(globalLoaderText(""));
  }
}

function* watchAcquisitionCodeMaintenance() {
  yield takeEvery(
    GET_ASSET_AUDIT_HISTORY_LOG_GRID_DATA,
    getAssetAuditHistoryLogGridData
  );
  yield takeEvery(
    GET_ASSET_AUDIT_HISTORY_EXCEL_DATA,
    getAssetAuditHistoryExcelData
  );
}

export default function* combinedSaga() {
  yield all([watchAcquisitionCodeMaintenance()]);
}
